import styled from 'styled-components'

export const PostTypeWrapper = styled.div`
  position: relative;
  clear: left;
  display: flex;
  padding: 10px;
  border-bottom: 1px solid var(--color-border-subtle);
  justify-content: space-between;
  color: var(--color-text-neutral);
`

export const RadioLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;

  &:hover {
    cursor: pointer;
  }

  ${({ disabled }: { disabled?: boolean }): string | false | undefined =>
    disabled &&
    `
  cursor: not-allowed;
  color: var(--color-text-disabled);`}
`

export const RadioInput = styled.input`
  margin-right: 6px;
  vertical-align: top;

  .vrLight &,
  .vrDark & {
    accent-color: green;
  }

  &:hover {
    cursor: pointer;
  }
  &[disabled] {
    cursor: not-allowed;
  }
`
